<template>
  <multiselect
    v-model="selected"
    :class="[{'spl-singleselect--valid': !invalid && !isEmpty}, {'spl-singleselect--invalid': invalid}, 'spl-singleselect']"
    :options="options"
    :disabled="disabled"
    :close-on-select="true"
    :clear-on-select="false"
    :hide-selected="hideSelected"
    :placeholder="null"
    :label="label"
    :track-by="trackBy"
    :searchable="searchable"
    :open-direction="$mq === 'sm' ? 'above' : 'auto'"
    :max-height="$mq === 'sm' ? 140 : 300"
    :internal-search="internalSearch"
    @search-change="onSearchChanged"
    @close="$emit('close')"
    @input="onInput">
    <template slot="noOptions">
      {{ noOptions }}
    </template>
    <template slot="placeholder">
      <div v-if="icon === 'search'" class="icon-search" />
      <span :class="{'placeholder-with-icon': icon !== 'none'}">
        {{ placeholder }}
      </span>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { find } from 'lodash'
export default {
  components: { Multiselect },
  props: {
    options: {
      type: Array,
      default: function () {
        return []
      }
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'label'
    },
    trackBy: {
      type: String,
      default: 'value'
    },
    noOptions: {
      type: String,
      default: 'List is empty.'
    },
    icon: {
      type: String,
      default: 'none'
    },
    searchable: {
      type: Boolean,
      default: true
    },
    internalSearch: {
      type: Boolean,
      default: true
    },
    hideSelected: {
      type: Boolean,
      default: true
    },
    selectedKey: {
      default: null
    },
    disabled: {
      default: false
    },
    index: {
      type: Number,
      default: NaN
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: null,
      firstValueSet: false
    }
  },
  computed: {
    isEmpty () {
      return this.selected == null
    }
  },
  watch: {
    selectedKey (newValue) {
      // Every time we set a selected key try to select it
      this.checkSelectedKey()
    },
    selected (newValue) {
      this.firstValueSet = true
    }
  },
  mounted () {
    // On startup check if we have a selected item
    this.checkSelectedKey()
  },
  methods: {
    onSearchChanged (query) {
      this.$emit('search-change', query)
    },
    // Searches the options for the selected Key
    checkSelectedKey () {
      var searchObject = {}
      searchObject[this.trackBy] = this.selectedKey
      this.selected = find(this.options, searchObject)
      if (this.selected) {
        this.$emit('updateDropdownValue', this.selected, this.index)
      }
    },
    onInput (selected) {
      this.$emit('updateDropdownValue', this.selected, this.index)
      this.$emit('input', selected ? selected[this.trackBy] : null)
    },
    reset () {
      this.selected = null
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>

<style lang="scss">
@import "../../variables.scss";
.spl-singleselect {
  @include mobile() {
    & .multiselect {
      &__input {
        width: calc(100% - 50px) !important;
      }
    }
  }

  .multiselect__tags {
    border: 1px solid $lightYellowBorder;
    border-radius: 4px;
  }

  .multiselect__tags:focus-within {
    border: 1px solid #555;
  }

  .multiselect__option--highlight {
    background: $middleYellow;
    color: black;
  }

  .multiselect__option--highlight:after {
    content: attr(data-select);
    background: $middleYellow;
    color: black;
  }

  .icon-search {
    background-image: url(../../assets/icon-search.svg);
    background-repeat: no-repeat;
    width: 20px;
    height: 20px;
    position: absolute;
    left: 10px;
    top: 12px;
  }

  .placeholder-with-icon {
    position: absolute;
    left: 35px;
  }
  &-nomargin {
    margin-bottom: 0;
  }
  &[disabled] {
    opacity: 0.4;
  }
  &--invalid .multiselect__tags,
  &--invalid .multiselect__input {
    background-color: $redBackgroundLight;
    border-color: $errorRed;
  }

  &--valid::after {
    content: url(../../assets/icon-check.svg);
    width: 10px;
    height: 10px;
    position: absolute;
    right: 56px;
    top: 11px;
  }
}
@include mobile() {
  .multiselect--active {
    z-index: 9999 !important;
  }
}
</style>
